<template>
  <CRow class="mt-5 pt-5">
    <CCol sm="12" class="d-flex flex-column">
      <h1 class="titlePage font-weight-normal text-capitalize pb-4">
        {{ $t('templates.email.simple-text.title') }}
      </h1>
      <a @click="$router.go(-1)" class="text-decoration-none d-flex-inline align-items-center font-weight-normal text-gray-600 cursor-pointer mb-5">
        <CIcon name="arrow" :height="20" class="icon__rotateLeft mr-2" viewBox="0 0 32 32" />
        {{ $t('general.BACK') }}
      </a>
    </CCol>
    <CCol sm="12">
      <CRow class="my-4">
        <CCol md="12" sm="12">
          <transition name="fade">
            <MenssageAlert :messages="messages" />
          </transition>
        </CCol>
        <div v-if="loading" style="min-height: 300px" class="d-flex justify-content-center align-items-center dataTable__loading">
          <CSpinner class="my-3" color="primary" />
        </div>
        <CCol v-show="!loading" md="12" sm="12">
          <CRow class>
            <CCol sm="12" md="4">
              <h3 class="font-weight-normal">{{ $t('templates.email.simple-text.name') }}</h3>
              <CInput placeholder="Template Name" class="my-4" v-model="templateName"> </CInput>
            </CCol>
            <CCol class="h-100" sm="12">
              <h5 class="font-weight-normal">{{ $t('templates.email.simple-text.text') }}</h5>
              <div class="border-line"></div>
            </CCol>
          </CRow>
          <CRow class="mb-4 mt-3 bg-gray-200 p-4">
            <CCol md="12" sm="12">
              <CustomFields @addCustomFieldsToText="addCustomFieldsToText" @addSubscribeText="addSubscribeText" simpleText />
            </CCol>
            <CCol md="12" sm="12">
              <CTextarea
                v-model="emailSimpleText"
                size="lg"
                ref="textArea"
                :label="$t('templates.email.simple-text.label')"
                addInputClasses="h-auto"
                rows="10"
              ></CTextarea>
            </CCol>
          </CRow>
          <div class="mt-5">
            <CButton
              v-if="this.$route.name != 'create-simple-text'"
              @click="saveTemplateText()"
              color="primary "
              class="text-uppercase py-2 px-3 font-weight-bold"
              >{{ $t('templates.email.simple-text.confirm') }}</CButton
            >

            <CButton v-else @click="saveEmailSimpleText()" color="primary " class="text-uppercase py-2 px-3 font-weight-bold">{{
              $t('templates.email.simple-text.create')
            }}</CButton>
          </div>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
import services from '@/services.js'
import CustomFields from '@/components/CustomFields'
import MenssageAlert from '@/components/MenssageAlert'
import { DYNAMIC_TEMPLATE_DESTINATION_TYPE } from '../constants'

const contentTypeEnum = {
  simpleText: 1,
  HTML: 2,
}

export default {
  components: {
    CustomFields,
    MenssageAlert,
  },
  name: 'ImporHTML',
  data() {
    return {
      loading: false,
      messages: [],
      customTypes2: null,
      customTypes: null,
      template: {},
      templateName: '',
      emailSimpleText: '',
      customFieldSelected: null,
      scrollTopInterval: null,
    }
  },

  mounted() {
    if (this.$route.params.id) this.getTemplate()
  },
  computed: {
    isDestinationTypeCampaign() {
      return DYNAMIC_TEMPLATE_DESTINATION_TYPE.CAMPAIGN == this.$route.params.dynamicDestinationType
    },

    isDestinationTypeWorkflow() {
      return DYNAMIC_TEMPLATE_DESTINATION_TYPE.WORKFLOW == this.$route.params.dynamicDestinationType
    },

    hasDynamicIndex() {
      return this.$route.params.dynamicIndex >= 0
    }
  },
  methods: {
    async getTemplate() {
      this.messages = []
      this.loading = true
      try {
        let organizationId = this.$store.state.auth.organizationId
        const TEMPLATE_PAYLOAD = await services.getTemplate(organizationId, this.$route.params.id)
        this.emailSimpleText = TEMPLATE_PAYLOAD.data.data.emailSimpleText
        this.templateName = TEMPLATE_PAYLOAD.data.data.name

        this.template.name = TEMPLATE_PAYLOAD.data.data.name
        this.template.emailSimpleText = TEMPLATE_PAYLOAD.data.data.emailSimpleText
        this.template.emailTemplateId = TEMPLATE_PAYLOAD.data.data.emailTemplateId
      } catch (error) {
        this.messages.push({
          status: 'danger',
          text: error.response.data.message || 'Error',
        })
      } finally {
        this.loading = false
      }
    },

    addCustomFieldsToText(field) {
      const textarea = Array.from(this.$refs.textArea.$el.childNodes).filter((item) => item.nodeName == 'TEXTAREA')
      textarea[0].focus()

      if (field === null) {
        return
      }

      document.execCommand('insertText', false, '[' + field + '] ')
    },

    addSubscribeText() {
      const textarea = Array.from(this.$refs.textArea.$el.childNodes).filter((item) => item.nodeName == 'TEXTAREA')
      textarea[0].focus()

      document.execCommand(
        'insertText',
        false,
        `${this.$t('templates.general.fields.textUnsubscribe')}
${this.$t('templates.general.fields.unsubscribe')}`,
      )
    },

    goToCampaign(template, contentType) {
      this.$router.push({
        name: 'campaignCreator',
        params: {
          messages: [
            {
              status: 'success',
              text: this.$t('templates.email.simple-text.message-templated-added', template.name),
            },
          ],
          campaignId: this.$route.params.dynamicId,
          indexChannel: this.$route.params.dynamicIndex,
          template: {
            contentType: contentType,
            id: template.emailTemplateId,
            name: template.name,
            thumbnailUri: template.thumbnailUri,
            emailSimpleText: template.emailSimpleText,
          },
        },
      })
    },

    goToWorkflow(template, contentType) {
      this.$router.push({
        name: 'automationWorkflow',
        params: {
          messages: [
            {
              status: 'success',
              text: this.$t('templates.email.simple-text.message-templated-added', template.name),
            },
          ],
          workflowId: this.$route.params.dynamicId,
          indexStep: this.$route.params.dynamicIndex,
          template: {
            contentType: contentType,
            id: template.emailTemplateId,
            name: template.name,
            thumbnailUri: template.thumbnailUri,
            emailSimpleText: template.emailSimpleText,
          },
        },
        hash: this.$route.hash
      })
    },

    scrollTop() {
      this.scrollTopInterval = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.scrollTopInterval)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 20)
    },

    verifyText() {
      if (this.emailSimpleText.length == 0) {
        this.messages.push({
          status: 'danger',
          text: this.$t('templates.email.simple-text.empty'),
        })
        return false
      }

      if (this.emailSimpleText && this.emailSimpleText.length) {
        if (this.emailSimpleText.indexOf('https://UNSUB_LINK_EN') > -1 || this.emailSimpleText.indexOf('https://UNSUB_LINK_PT') > -1) {
          return true
        }
        this.messages.push({
          status: 'danger',
          text: this.$t('templates.editorHtml.unsubscribe'),
        })
        this.scrollTop()
        return false
      }
    },

    saveTemplateText() {
      this.messages = []
      this.loading = true
      let organizationId = this.$store.state.auth.organizationId

      services
        .sendSimpleText(organizationId, this.$route.params.id, {
          emailSimpleText: this.emailSimpleText,
          name: this.templateName,
          type: 1,
        })
        .then((result) => {
          this.messages.push({
            status: 'success',
            text: result.data.data.message || 'Text simple was salved',
          })

          if (!this.$route.params.dynamicId || !this.hasDynamicIndex) {
            this.$router.push({ name: 'template-emails' })
          }

          if (this.isDestinationTypeCampaign) {
            this.goToCampaign(result.data.data, this.$route.params.contentType)
            return
          }

          if (this.isDestinationTypeWorkflow) {
            this.goToWorkflow(result.data.data, this.$route.params.contentType)
          }
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.Message || error.response.data.message,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    saveEmailSimpleText() {
      this.messages = []

      if (!this.verifyText()) return

      let formData = new FormData()

      formData.append('Name', this.templateName)
      formData.append('EmailSimpleText', this.emailSimpleText)
      formData.append('type', 1)

      if (this.isDestinationTypeCampaign) {
        formData.append('CampaignId', this.$route.params.dynamicId)
      }
      if (this.isDestinationTypeWorkflow) {
        formData.append('WorkflowId', this.$route.params.dynamicId)
      }

      this.loading = true
      let organizationId = this.$store.state.auth.organizationId

      services
        .sendTemplatesEmail(organizationId, formData)
        .then((result) => {
          this.messages.push({
            status: 'success',
            text: result.data.data.message || 'Text simple was salved',
          })

          if (!this.$route.params.dynamicId || !this.hasDynamicIndex) this.$router.push({ name: 'template-emails' })

          if (this.isDestinationTypeCampaign) {
            this.goToCampaign(result.data.data, contentTypeEnum.simpleText)
          }
          if (this.isDestinationTypeWorkflow) {
            this.goToWorkflow(result.data.data, contentTypeEnum.simpleText)
          }
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message || 'Error',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.h-300.form-control {
  height: auto;
}
</style>
